<template>
  <div class="grid-body">
    <table class="table">
      <thead>
        <tr class="bg-gray">
          <th width="50"></th>
          <th>ID</th>
          <th>Payment Date</th>
          <th>Recipient</th>
          <th class="text-center">Comment</th>
          <th class="text-center">Total Amount</th>
          <th class="text-center">Attachment</th>
          <th class="text-center" width="50"></th>
        </tr>
      </thead>
      <tbody v-for="(invoice, index) in invoices" :key="invoice.id">
        <tr>
          <td>
            <button
              class="btn btn-primary"
              v-if="!invoice.show"
              @click="invoice.show = !invoice.show"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i>
            </button>
            <button
              class="btn btn-danger"
              v-else
              @click="invoice.show = !invoice.show"
            >
              <i class="fa fa-times-circle" aria-hidden="true"></i>
            </button>
          </td>
          <td class="text-bold">
            <router-link
              :to="{
                path:
                  '/accounting/' +
                  $route.params.type +
                  '/invoice/edit/' +
                  invoice.id,
              }"
              >{{ invoice.id }}
            </router-link>
          </td>
          <td>
            {{
              moment(invoice.transaction_date_time).format(
                "DD MMM, YYYY hh:mm a"
              )
            }}
          </td>

          <td>
            {{ invoice.contact_name }}
          </td>
          <td>
            {{ invoice.invoice_note }}
          </td>

          <td class="text-right">
            {{ ezy.comma(invoice.grand_total) }} &#3647;
          </td>

          <td class="text-center">
            <a
              v-if="invoice.attachments"
              :href="invoice.attachments"
              target="_blank"
              class="badge badge-info pointer"
            >
              <i class="fa fa-eye" aria-hidden="true"></i> View
            </a>
            <span class="badge badge-info pointer" v-else> No Attachment </span>
          </td>

          <td class="text-center">
            <div class="btn-group fabric-dropdown">
              <button
                data-toggle="dropdown"
                class="btn btn-primary dropdown-toggle btn-demo-space"
              >
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu pull-right">
                <li>
                  <router-link
                    :to="{
                      path:
                        '/accounting/' +
                        $route.params.type +
                        '/invoice/edit/' +
                        invoice.id,
                    }"
                    class="pointer"
                  >
                    <i class="fa fa-edit" aria-hidden="true"></i> Edit
                  </router-link>
                </li>
                <li>
                  <a class="pointer" @click="$emit('delete', index)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a
                  >
                </li>
              </ul>
            </div>
          </td>
        </tr>

        <tr v-if="invoice.show">
          <td colspan="9">
            <center>
              <table class="table">
                <thead>
                  <tr class="bg-yellow">
                    <th>Item Name</th>
                    <th>Category 1</th>
                    <th>Category 2</th>
                    <!-- <th>Specification</th> -->
                    <th>Unit Price</th>
                    <th>Unit</th>
                    <th>Quantity</th>
                    <th>Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, itemIndex) in invoice.invoice_items"
                    :key="itemIndex"
                  >
                    <td>{{ item.name }}</td>
                    <td>{{ item.category_1 }}</td>
                    <td>{{ item.category_2 }}</td>
                    <!-- <td>{{item.name}}</td> -->
                    <td>{{ item.unit_price }}</td>
                    <td>{{ item.unit }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.total_price }}</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </td>
        </tr>
      </tbody>
      <tbody>
        <tr v-if="loading">
          <td class="text-center" colspan="9">
            <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
            Loading ...
          </td>
        </tr>
        <tr v-if="noMoreData">
          <td class="text-center" colspan="9">No More Data</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";
import ezy from "../Tools/ezyFunction";
export default {
  props: ["invoices", "loading", "noMoreData"],
  data() {
    return {
      ezy,
      moment,
    };
  },
  methods: {},
};
</script>
<style scoped>
.bg-gray {
  background: #e5e9eccc;
}
.bg-yellow {
  background: #ffff31cc !important;
}
.table > tbody > tr > td {
  border: 1px solid #e8edf1;
}
</style>
